import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index'
import Home from './views/Home.vue'
import Preferences from './views/Preferences'
import Detail from './views/Detail.vue'
import Step1 from './views/Step1.vue'
import Step2 from './views/Step2.vue'
import Step3 from './views/Step3.vue'
import Step4 from './views/Step4.vue'
import ThankYou from './views/ThankYou'
import DefaultLayout from './layouts/default'
import Callback from './views/Callback'
import FavoritesMiddleware from './middlewares/favoritesMiddleware'
import Stackingplan from './views/Stackingplan'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/:selector_id',
      component: DefaultLayout,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home
        },
        {
          path: 'preferences',
          name: 'preferences',
          component: Preferences
        },
        {
          path: 'kavelkaart/:object_id',
          name: 'detail',
          component: Detail
        },
        {
          path: 'step-1',
          name: 'step1',
          component: Step1,
          meta: {
            middleware: FavoritesMiddleware
          }
        },
        {
          path: 'step-2',
          name: 'step2',
          component: Step2,
          meta: {
            middleware: FavoritesMiddleware
          }
        },
        {
          path: 'step-3',
          name: 'step3',
          component: Step3,
          meta: {
            middleware: FavoritesMiddleware
          }
        },
        {
          path: 'step-4',
          name: 'step4',
          component: Step4,
          meta: {
            middleware: FavoritesMiddleware
          }
        },
        {
          path: 'bedankt',
          name: 'bedankt',
          component: ThankYou,
          meta: {
            middleware: FavoritesMiddleware
          }
        },
        {
          path: 'callback/:token',
          name: 'callback',
          component: Callback
        },
        {
          path: 'stackingplan',
          name: 'stackingplan',
          component: Stackingplan
        },
        {
          path: 'stackingplan/*',
          component: Stackingplan
        }
      ]
    },
  ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
        ? to.meta.middleware
        : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});


export default router
